import { connect } from 'react-redux'
import KegCollectionBookings from './components'
import withNoPermissions from '../OperateAsCustomerUser/withNoPermissions'
import { HISTORY_TABLE_NO_RESULTS_DEFAULT_MESSAGE } from '../../../constants'
import { getProp } from '../../../redux/selectors/kegCollectionBookings'

import { getProp as getCurrentUserEmployeeProp } from '../../../redux/selectors/currentUserEmployee'
import { getProp as getCurrentUserProps } from '../../../redux/selectors/currentUser'

const mapStateToProps = state => {
  const {
    bookingsList: {
      content,
      pageNumber,
      pageSize,
      totalElements,
      totalPages,
      isFetching,
      didFetchSucceed,
      didFetchFail,
    },
    bookingsExportList,
    venuesList,
    selectedVenueCollectionInfo,
    createKegCollectionRequestStatusState,
    collectorsList,
    bookingsListViewSearchFilterOptions,
  } = getProp(state)

  const currentUserId = getCurrentUserEmployeeProp(state, 'userId')
  const currentUserOperateAs = getCurrentUserProps(state)

  return {
    bookingsList: content,
    bookingsExportList,
    pageNumber,
    pageSize,
    totalElements,
    totalPages,
    isFetching,
    didFetchSucceed,
    didFetchFail,
    noResultsMessage: HISTORY_TABLE_NO_RESULTS_DEFAULT_MESSAGE,
    venuesList,
    selectedVenueCollectionInfo,
    currentUserId,
    createKegCollectionRequestStatusState,
    currentUserOperateAs,
    collectorsList,
    bookingsListViewSearchFilterOptions,
  }
}

export default withNoPermissions(connect(mapStateToProps)(KegCollectionBookings))
